import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectInput } from '../../interfaces/select-input';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-multi-select-input',
  imports: [CommonModule, ReactiveFormsModule, MultiSelectModule, MessageModule ],
  templateUrl: './multi-select-input.component.html',
  styleUrl: './multi-select-input.component.scss'
})
export class MultiSelectInputComponent {
  
  @Input() form!: FormGroup;
  @Input() field!: string;
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() options!: SelectInput[];
  @Input() fieldLabel = "label";
  @Input() fieldCode = "code";

}
